import React, { Component } from 'react';
import { connect } from 'react-redux';
import classes from './AdminLoginPage.css'
import * as actionTypes from '../../../store/actions';
import * as actionCreators from '../../../store/actionCreators';
import AdminAuth from '../../../services/AdminAuth';

export class AdminLoginPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            username: '',
            password: '',
            submitted: false
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

        if (AdminAuth.isAdminAuthenticated()) {
            this.props.history.push("/admin/rates");
        }

    }

    handleChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    handleSubmit(e) {
        e.preventDefault();

        this.setState({ submitted: true });

        if (this.state.username.length > 0 && this.state.password.length > 0) {
            const { username, password } = this.state;
            this.props.adminLogin(username, password);
        }
    }

    componentDidMount() {
        this.props.setAdminPage();
        if (this.props.updateMenuState) {
            this.props.updateMenuState();
        }

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.adminLoggedIn && AdminAuth.isAdminAuthenticated()) {
            this.props.history.push("/admin/rates");
        }
    }

    componentWillReceiveProps(nextProps) {
        
    }

    render() {
        const { username, password, submitted } = this.state;
        return (
            <div className={classes.AdminLoginForm}>
                <form name="form" onSubmit={this.handleSubmit}>
                    <div className={classes.AdminLoginFormField}>
                        <label>Username:</label>
                        <input
                            className={classes.username}
                            placeholder="username"
                            type="text"
                            name="username"
                            value={username}
                            onChange={this.handleChange}
                        />
                        {submitted && username.length === 0 &&
                            <div className={classes.error}>Username is required</div>
                        }
                    </div>
                    <div className={classes.AdminLoginFormField}>
                        <label>Password:</label>
                        <input
                            className={classes.password}
                            placeholder="password"
                            type="password"
                            name="password"
                            value={password}
                            onChange={this.handleChange}
                        />
                        {submitted && password.length === 0 &&
                            <div className={classes.error}>Password is required</div>
                        }
                    </div>
                    {this.props.hasError && (
                    <div className={classes.error}>
                        <p>{this.props.errorMsg}</p>
                    </div>
                )}
                    <div className={classes.buttonContainer}>
                        <button className={classes.LoginButton}>Login</button>
                    </div>
                </form>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        adminLoggedIn: state.admin.adminLoggedIn,
        hasError: state.admin.adminLoginErrorState.hasError,
        errorMsg: state.admin.adminLoginErrorState.errorMessage
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateMenuState: () => dispatch({ type: actionTypes.ADMIN_LOGIN_PAGE }),
        setAdminPage: () => dispatch({
            type: actionTypes.SET_ADMIN_PAGE
        }),
        adminLogin: (username, password) => dispatch(actionCreators.adminLogin(username, password))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminLoginPage);


// WEBPACK FOOTER //
// ./src/containers/Admin/AdminLoginPage/AdminLoginPage.js